/* eslint-disable no-unused-vars */
/* eslint-disable no-shadow */
export enum Dtype {
  FLOAT = 'FLOAT'
}

export enum FieldType {
  DIMENSION = 'DIMENSION',
  METRIC = 'METRIC',
  INPUT = 'INPUT',
  OUTPUT = 'OUTPUT'
}
/* eslint-enable no-unused-vars */
/* eslint-enable no-shadow */

export interface IDataRow {
  [key: string]: string | number;
}

export interface ISimulationResponse {
  simulation_id: number;
  data: {
    OWN: IDataRow[];
    TOTAL: IDataRow[];
  };
}

export interface ISimTableColumnMetadata {
  is_checkbox_field: boolean;
  checkbox_value_field_name: string;
  is_gb_checkbox_active: boolean;
  /** ID of the field */
  field_id: number;
  metric_id: number;
  /** The key to map to the data received from the backend */
  name: string;
  /** Top level header to be displayed on the column */
  field_display_alias: string;
  /** Used by the backend - no need to bother */
  field_alias: string;
  field_value_dtype: string;
  field_format: string;
  type: string;
  currency_label: string;
  is_grouped: boolean;
  dtype: Dtype;
  field_number_format: string;
  field_type: FieldType;
  is_active: boolean;
  /** If true that means there should be a `current` column as a sub header with data mapped by the key name */
  is_current_active: boolean;
  /** If true that means there should be a `new` column where user will enter the absolute value for the record */
  is_new_active: boolean;
  /** If true that means there should be a `change percentage` column where user will enter the change in percentage value for the record */
  is_perc_active: boolean;
  is_cf: boolean;
  is_default: boolean;
  /** If true that means there should be a `additional change percentage` column where user will enter the change in percentage for the record */
  is_additional_active: boolean;
  /** If true that means the `new` column should have a text field besides the header and the value entered by user there should reflect on all the records of that column */
  is_gb_new_active: boolean;
  /** If true that means the `change percentage` column should have a text field besides the header and the value entered by user there should reflect on all the records of that column */
  is_gb_perc_active: boolean;
  /** If true that means the `additional` column should have a text field besides the header and the value entered by user there should reflect on all the records of that column */
  is_gb_additional_active: boolean;
  /** Whether the column is showing percentage change or absolute change */
  is_perc_abs_col: boolean;
  is_own_view: boolean;
  /** If true that means the column is part of the retailer KPI table */
  is_retailer_view: boolean;
  is_retailer_group_active: boolean;
  /** The prefix to be displayed against the value */
  prefix_label: string;
  /** The suffix to be displayed against the value */
  suffix_label: string;
  /** The order of rendering the columns */
  sort_order: number;
  /** The key name in the table data to bind the `current` value to */
  field_name: string;
  /** The key name in the table data to bind `new` input to */
  new_value_field_name: string;
  /** The key name in the table data to bind `percentage change` input to */
  perc_change_value_field_name: string;
  /** The key name in the table data to bind `additional` input to */
  additional_value_field_name: string;
  /** Indicator whether any change in this columns % change or additional change should also be reflected in any other `linked` columns % change */
  linked_to_field_name: string;
  /** Formula to recalculate percentage change value as per the business logic once user has manually changed it */
  per_change_formula: string;
  /** Formula to recalculate new change value as per the business logic once user has manually changed it */
  new_formula: string;
  /** Formula to recalculate additional change value as per the business logic once user has manually changed it */
  additional_formula: string;
}

export interface TableMetadata {
  data: any[];
  displayColumnData: any[];
  inputColumnData: any[];
  absOutputColumnData: any[];
  percOutputColumnData: any[];
}

export interface Scenario {
  created_at: string;
  description: string;
  modified_at: string;
  name: string;
  price_action_at: string;
  isSelected: boolean;
}

export interface SimulationScenario {
  Active: Scenario[];
  Archived: Scenario[];
  Finalized: Scenario[];
  All: Scenario[];
}

export interface ISimulationTableViewMetadata {
  DISPLAY: ISimTableColumnMetadata[];
  INPUT: ISimTableColumnMetadata[];
  OUTPUT: ISimTableColumnMetadata[];
}

export interface GlobalValueResult {
  globalPA1Value: string;
  globalPA2Value?: string;
}